import { render, staticRenderFns } from "./ClientBox.vue?vue&type=template&id=bc44af18&"
import script from "./ClientBox.vue?vue&type=script&lang=js&"
export * from "./ClientBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports